// frontend/src/pages/Dashboard/InBoundShipments/index.jsx
import React from "react";
import styles from './InBoundShipments.module.css';

const InBoundShipments = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h1 className={styles.title}>InBound Shipments</h1>
        </div>
        
        <div className={styles.contentCard}>
          <div className={styles.welcomeText}>Hello World! - inbound shipments page</div>
          <div className={styles.subText}>This is the InBound Shipments page. Your content will go here.</div>
        </div>
      </div>
    </div>
  );
};
  
export default InBoundShipments;